import type { settingTypes } from '@ipfabric/utils';
import { type Vendor, isVendorAws } from '../vendorTypes';

const sanitizeAwsAssumeRoles = (
  vendor: settingTypes.AwsApiSettings,
): settingTypes.AwsApiSettings => {
  const { assumeRoles, ...v } = vendor;

  // remove empty lines
  const filteredAssumeRoles = assumeRoles?.filter((r) => r.role !== '');

  // omit empty assumeRoles
  return {
    ...v,
    assumeRoles: filteredAssumeRoles?.length ? filteredAssumeRoles : [],
  };
};

export const updateVendorForRequest = (vendor: Vendor): Vendor => {
  if (isVendorAws(vendor)) {
    return sanitizeAwsAssumeRoles(vendor);
  }

  return vendor;
};
